export default "__VITE_ASSET__CioIhKhZ__"